import { GroupedOption } from '@/components/ui/react-select/ReactGroupSelect';
import { UpworkCrawlerCategory, UpworkCrawlerLocation } from '@/types';

export function mapCategoriesToGroupedOptions(
  categories: UpworkCrawlerCategory[]
): GroupedOption[] {
  return categories && categories.length > 0
    ? categories.map((category) => ({
        label: category.label,
        options: [
          {
            value: category.uid,
            label: `All - ${category.label}`,
          },
          ...category.subcategories.map((subcategory) => ({
            value: `${category.uid}-${subcategory.uid}`,
            label: subcategory.label,
          })),
        ],
      }))
    : [];
}

export function mapLocationsToGroupedOption(locations: UpworkCrawlerLocation[]): GroupedOption[] {
  if (locations && locations.length > 0) {
    const grouped: { [key: string]: UpworkCrawlerLocation[] } = {};

    locations.forEach((location) => {
      const { type } = location;
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push(location);
    });

    return Object.entries(grouped).map(([label, options]) => ({
      label,
      options: options.map((location) => ({
        value: location.label,
        label: location.label,
      })),
    }));
  }

  return [];
}
